export const invertedMessages = {
  'Go Back': 'CERTS_DETAILS_CAUGHT_UP_BUTTON',
  Refresh: 'Refresh.ATTESTATIONS',
  'This page of the certification did not load properly due to a network issue. Please refresh or try again later.':
    'CERTS_GOLBAL_ERROR_DESCRIPTION',
  'Could not Load Page': 'CERTS_GLOABL_ERROR_TITLE',
};
